import { useHistory } from 'react-router';

const useNavigateWithoutFullPageReload = () => {
  const history = useHistory();

  const navigateWithoutFullPageReload = (url: string) => history.push(url);

  return navigateWithoutFullPageReload;
};

export default useNavigateWithoutFullPageReload;
